import { AxiosPromise } from 'axios';
import { TokenAV1I } from '../interfaces/TokenAV1Interface';
import http from './config';

const getTokenAV1 = (id: string | '' | null): AxiosPromise<TokenAV1I> => {
    return http.post('/v1/sesion/av1/crear', {
        id
    });
};

const refreshTokenAV1 = (
    refresh_token: string | '' | null
): AxiosPromise<TokenAV1I> => {
    return http.post('/v1/sesion/av1/renovar', {
        refresh_token
    });
};

export default {
    getTokenAV1,
    refreshTokenAV1
};
